const Routers = {
  All: "/*",
  Dashboard: "/",
  Login: "/login",

  // Variable Cost Register
  VariableCostRegister: "/variable-cost-register",

  // Application Create
  ApplicationCreate: "/application-create",
  ApplicationReview: "/application-review",

  // Contracts
  ContractsList: "/contracts-list",
  ContractsDetail: "/contracts-detail",

  // Notice
  Notice: "/notice",

  // Receipt Invoice
  ReceiptInvoice: "/receipt-invoice",

  // Subrogation Payment
  SubrogationPayment: "/subrogation-payment",

  // Inclusive Contract
  InclusiveContractApplication: "/inclusive-contracts",
  InclusiveContractDetail: "/inclusive-contract-detail",
  InclusiveContractCreate: "/inclusive-contract-create",

  // Received Invoice
  ReceivedInvoice: "/received-invoice",

  // Cancellation Register
  CancellationRegister: "/cancellation-register",

  // Error Pages
  BadRequest: "/400",
  Forbidden: "/403",
  NotFound: "/not-found",

  // Health Check
  HealthCheck: "/healthcheck",

  // Maintenance
  Maintenance: "/maintenance"
};

export default Routers;
